
/**
 * If the value is not null, return true, otherwise return false.
 * @param {T | null} value - T | null - The value to check.
 */
export const notNull = <T>(value: T | null): value is T => value !== null;

/**
 * If the type of the value is 'boolean', then return true, otherwise return false.
 * @param {any} val - any - The value to check
 */
export const isBoolean = (val: any) => 'boolean' === typeof val;

export const isString = (val: any) => 'string' === typeof val;